export default function Activities() {
  const activities = [
    {
      icon: 'ri-music-2-line',
      title: 'ライブイベントの企画・運営',
      description: '地域のライブハウスと連携し、質の高い音楽イベントを定期的に開催しています。新人アーティストの発掘から、ベテランアーティストの公演まで、幅広いジャンルの音楽を提供しています。'
    },
    {
      icon: 'ri-team-line',
      title: 'アーティスト支援活動',
      description: '登録アーティストに対して、ライブ出演機会の提供、プロモーション支援、音楽制作のアドバイスなど、総合的なサポートを行っています。音楽活動を続けやすい環境づくりに取り組んでいます。'
    },
    {
      icon: 'ri-building-line',
      title: '会場ネットワークの構築',
      description: '東京都内の優良なライブハウスとのネットワークを構築し、アーティストと会場をつなぐ架け橋となっています。各会場の特性を活かした最適なマッチングを実現しています。'
    },
    {
      icon: 'ri-calendar-event-line',
      title: '音楽文化の普及活動',
      description: '地域住民向けの音楽イベントやワークショップを開催し、音楽文化の普及に努めています。音楽を通じた地域コミュニティの活性化を目指しています。'
    }
  ];

  return (
    <section id="activities" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">地域のライブハウス活動紹介</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            日本音楽会場協会 東京クラブは、地域の音楽シーンを支え、発展させるために様々な活動を行っています。
            ライブハウスとアーティスト、そして音楽を愛する人々をつなぐ架け橋として、東京の音楽文化の発展に貢献しています。
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {activities.map((activity, index) => (
            <div key={index} className="bg-white rounded-lg p-8 shadow-sm hover:shadow-md transition-shadow">
              <div className="w-14 h-14 flex items-center justify-center bg-gray-900 text-white rounded-lg mb-6">
                <i className={`${activity.icon} text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{activity.title}</h3>
              <p className="text-gray-600 leading-relaxed">{activity.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}